import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { TrendingUp, Building2, Store, MapPin, Star, Filter, ArrowUpRight, ArrowDownRight, CheckCircle2, XCircle, Package, Coffee, Fish, Beef, Gift, Wine, Truck, Car, Mail, Leaf, QrCode, CreditCard, Salad } from 'lucide-react';
import { KPICard } from '../components/ui/KPICard';
import { Card } from '../components/ui/Card';
import { Badge } from '../components/ui/Badge';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell, ScatterChart, Scatter, ZAxis } from 'recharts';
// Service definitions
const services = [{
  id: 'payback',
  name: 'PAYBACK',
  icon: CreditCard
}, {
  id: 'ernaehrung',
  name: 'Ernährungsservice',
  icon: Salad
}, {
  id: 'fischtheke',
  name: 'Fischtheke',
  icon: Fish
}, {
  id: 'fleischtheke',
  name: 'Fleisch- & Wursttheke',
  icon: Beef
}, {
  id: 'treueaktionen',
  name: 'Treueaktionen',
  icon: Gift
}, {
  id: 'getraenkeshop',
  name: 'Getränkeshop',
  icon: Wine
}, {
  id: 'hermes',
  name: 'Hermes Paketshop',
  icon: Package
}, {
  id: 'kaesetheke',
  name: 'Käsetheke',
  icon: Coffee
}, {
  id: 'lieferservice',
  name: 'Lieferservice',
  icon: Truck
}, {
  id: 'parkplaetze',
  name: 'Parkplätze',
  icon: Car
}, {
  id: 'postfiliale',
  name: 'Postfiliale/DHL',
  icon: Mail
}, {
  id: 'regood_bowl',
  name: 'Regood Bowl',
  icon: Leaf
}, {
  id: 'regood_cup',
  name: 'Regood Cup',
  icon: Coffee
}, {
  id: 'scan_go',
  name: 'Scan & Go',
  icon: QrCode
}];
// Market data with services
const marketsData = [{
  id: 'hamburg-hafencity',
  name: 'EDEKA Center Hamburg-Hafencity',
  region: 'Nord',
  rating: 4.3,
  size: 2800,
  services: ['payback', 'ernaehrung', 'fischtheke', 'fleischtheke', 'treueaktionen', 'getraenkeshop', 'kaesetheke', 'lieferservice', 'parkplaetze', 'postfiliale', 'regood_bowl', 'regood_cup', 'scan_go']
}, {
  id: 'berlin-kreuzberg',
  name: 'EDEKA Neukauf Berlin-Kreuzberg',
  region: 'Minden-Hannover',
  rating: 3.8,
  size: 1200,
  services: ['payback', 'fleischtheke', 'treueaktionen', 'parkplaetze']
}, {
  id: 'muenchen-schwabing',
  name: 'EDEKA München-Schwabing',
  region: 'Südbayern',
  rating: 4.6,
  size: 1800,
  services: ['payback', 'ernaehrung', 'fischtheke', 'fleischtheke', 'treueaktionen', 'getraenkeshop', 'kaesetheke', 'lieferservice', 'parkplaetze', 'regood_bowl', 'regood_cup', 'scan_go']
}, {
  id: 'koeln-ehrenfeld',
  name: 'EDEKA Köln-Ehrenfeld',
  region: 'Rhein-Ruhr',
  rating: 3.5,
  size: 1100,
  services: ['payback', 'fleischtheke', 'treueaktionen']
}, {
  id: 'frankfurt-sachsenhausen',
  name: 'EDEKA Frankfurt-Sachsenhausen',
  region: 'Hessenring',
  rating: 4.4,
  size: 1600,
  services: ['payback', 'ernaehrung', 'fischtheke', 'fleischtheke', 'treueaktionen', 'getraenkeshop', 'kaesetheke', 'parkplaetze', 'postfiliale', 'scan_go']
}, {
  id: 'dortmund-innenstadt',
  name: 'EDEKA Dortmund-Innenstadt',
  region: 'Rhein-Ruhr',
  rating: 3.9,
  size: 1400,
  services: ['payback', 'fleischtheke', 'treueaktionen', 'getraenkeshop', 'parkplaetze', 'hermes']
}, {
  id: 'leipzig-sued',
  name: 'EDEKA Center Leipzig-Süd',
  region: 'Nordbayern',
  rating: 4.5,
  size: 2200,
  services: ['payback', 'ernaehrung', 'fischtheke', 'fleischtheke', 'treueaktionen', 'getraenkeshop', 'kaesetheke', 'lieferservice', 'parkplaetze', 'postfiliale', 'regood_bowl', 'scan_go']
}, {
  id: 'stuttgart-west',
  name: 'EDEKA Stuttgart-West',
  region: 'Südwest',
  rating: 4.2,
  size: 1500,
  services: ['payback', 'ernaehrung', 'fischtheke', 'fleischtheke', 'treueaktionen', 'kaesetheke', 'parkplaetze', 'regood_cup']
}, {
  id: 'freiburg-zentrum',
  name: 'EDEKA Freiburg-Zentrum',
  region: 'Südwest',
  rating: 4.1,
  size: 1350,
  services: ['payback', 'fischtheke', 'fleischtheke', 'treueaktionen', 'kaesetheke', 'parkplaetze', 'regood_bowl', 'regood_cup']
}, {
  id: 'kiel-zentrum',
  name: 'EDEKA Kiel-Zentrum',
  region: 'Nord',
  rating: 4.4,
  size: 1650,
  services: ['payback', 'ernaehrung', 'fischtheke', 'fleischtheke', 'treueaktionen', 'getraenkeshop', 'kaesetheke', 'lieferservice', 'parkplaetze', 'scan_go']
}, {
  id: 'hannover-list',
  name: 'EDEKA Hannover-List',
  region: 'Minden-Hannover',
  rating: 4.0,
  size: 1300,
  services: ['payback', 'fleischtheke', 'treueaktionen', 'getraenkeshop', 'parkplaetze', 'postfiliale']
}, {
  id: 'nuernberg-zentrum',
  name: 'EDEKA Nürnberg-Zentrum',
  region: 'Nordbayern',
  rating: 4.3,
  size: 1700,
  services: ['payback', 'ernaehrung', 'fischtheke', 'fleischtheke', 'treueaktionen', 'getraenkeshop', 'kaesetheke', 'parkplaetze', 'hermes', 'scan_go']
}, {
  id: 'dresden-altstadt',
  name: 'EDEKA Dresden-Altstadt',
  region: 'Nordbayern',
  rating: 4.1,
  size: 1250,
  services: ['payback', 'fischtheke', 'fleischtheke', 'treueaktionen', 'kaesetheke', 'parkplaetze', 'regood_bowl']
}, {
  id: 'duesseldorf-bilk',
  name: 'EDEKA Düsseldorf-Bilk',
  region: 'Rhein-Ruhr',
  rating: 4.2,
  size: 1550,
  services: ['payback', 'ernaehrung', 'fischtheke', 'fleischtheke', 'treueaktionen', 'getraenkeshop', 'kaesetheke', 'parkplaetze', 'scan_go']
}, {
  id: 'bremen-mitte',
  name: 'EDEKA Bremen-Mitte',
  region: 'Nord',
  rating: 3.9,
  size: 1150,
  services: ['payback', 'fleischtheke', 'treueaktionen', 'parkplaetze', 'hermes']
},
// Markets without PAYBACK (smaller independent stores)
{
  id: 'rostock-stadtmitte',
  name: 'EDEKA Rostock-Stadtmitte',
  region: 'Nord',
  rating: 3.4,
  size: 800,
  services: ['fleischtheke', 'parkplaetze']
}, {
  id: 'magdeburg-altstadt',
  name: 'EDEKA Magdeburg-Altstadt',
  region: 'Minden-Hannover',
  rating: 3.6,
  size: 750,
  services: ['fleischtheke', 'treueaktionen', 'parkplaetze']
},
// Markets without Fleischtheke (express/convenience stores)
{
  id: 'berlin-mitte-express',
  name: 'EDEKA Express Berlin-Mitte',
  region: 'Minden-Hannover',
  rating: 3.7,
  size: 450,
  services: ['payback', 'treueaktionen', 'scan_go']
}, {
  id: 'muenchen-hbf',
  name: 'EDEKA Express München Hbf',
  region: 'Südbayern',
  rating: 3.5,
  size: 380,
  services: ['payback', 'treueaktionen']
},
// Markets without Treueaktionen (franchise stores)
{
  id: 'erfurt-zentrum',
  name: 'EDEKA Erfurt-Zentrum',
  region: 'Nordbayern',
  rating: 3.8,
  size: 950,
  services: ['payback', 'fleischtheke', 'kaesetheke', 'parkplaetze']
}, {
  id: 'chemnitz-innenstadt',
  name: 'EDEKA Chemnitz-Innenstadt',
  region: 'Nordbayern',
  rating: 3.6,
  size: 880,
  services: ['payback', 'fleischtheke', 'parkplaetze', 'hermes']
}];
// Calculate service impact on rating
const calculateServiceImpact = () => {
  return services.map(service => {
    const marketsWithService = marketsData.filter(m => m.services.includes(service.id));
    const marketsWithoutService = marketsData.filter(m => !m.services.includes(service.id));
    const avgWithService = marketsWithService.length > 0 ? marketsWithService.reduce((acc, m) => acc + m.rating, 0) / marketsWithService.length : 0;
    const avgWithoutService = marketsWithoutService.length > 0 ? marketsWithoutService.reduce((acc, m) => acc + m.rating, 0) / marketsWithoutService.length : 0;
    return {
      ...service,
      avgRatingWith: avgWithService,
      avgRatingWithout: avgWithoutService,
      impact: avgWithService - avgWithoutService,
      marketsCount: marketsWithService.length,
      penetration: marketsWithService.length / marketsData.length * 100
    };
  }).sort((a, b) => b.impact - a.impact);
};
const serviceImpactData = calculateServiceImpact();
// Level options
const levels = [{
  id: 'services',
  name: 'Service-Analyse',
  icon: Package
}, {
  id: 'markt',
  name: 'Markt-Übersicht',
  icon: Store
}];
export function ServicesReputationPage() {
  const [selectedLevel, setSelectedLevel] = useState<'services' | 'markt'>('services');
  const [selectedService, setSelectedService] = useState<string | null>(null);
  // Calculate overall stats
  const avgRating = marketsData.reduce((acc, m) => acc + m.rating, 0) / marketsData.length;
  const avgServices = marketsData.reduce((acc, m) => acc + m.services.length, 0) / marketsData.length;
  // Markets sorted by service count
  const marketsByServices = [...marketsData].sort((a, b) => b.services.length - a.services.length);
  const topServiceMarkets = marketsByServices.slice(0, 3);
  const lowServiceMarkets = marketsByServices.slice(-3).reverse();
  // Correlation between service count and rating
  const correlationData = marketsData.map(m => ({
    name: m.name,
    serviceCount: m.services.length,
    rating: m.rating,
    z: m.size
  }));
  // Calculate correlation
  const n = correlationData.length;
  const sumX = correlationData.reduce((acc, d) => acc + d.serviceCount, 0);
  const sumY = correlationData.reduce((acc, d) => acc + d.rating, 0);
  const sumXY = correlationData.reduce((acc, d) => acc + d.serviceCount * d.rating, 0);
  const sumX2 = correlationData.reduce((acc, d) => acc + d.serviceCount * d.serviceCount, 0);
  const sumY2 = correlationData.reduce((acc, d) => acc + d.rating * d.rating, 0);
  const correlation = (n * sumXY - sumX * sumY) / Math.sqrt((n * sumX2 - sumX * sumX) * (n * sumY2 - sumY * sumY));
  // Top impact services
  const topImpactServices = serviceImpactData.filter(s => s.impact > 0).slice(0, 5);
  return <div className="p-6 space-y-6 overflow-y-auto h-[calc(100vh-64px)]" data-id="element-1210">
      {/* Level Filter */}
      <Card className="!p-4" data-id="element-1211">
        <div className="flex items-center gap-4 flex-wrap" data-id="element-1212">
          <div className="flex items-center gap-2 text-sm font-medium text-gray-700" data-id="element-1213">
            <Filter size={16} data-id="element-1214" />
            <span data-id="element-1215">Ansicht:</span>
          </div>
          <div className="flex flex-wrap gap-2" data-id="element-1216">
            {levels.map(level => {
            const isSelected = selectedLevel === level.id;
            const Icon = level.icon;
            return <button key={level.id} onClick={() => setSelectedLevel(level.id as any)} className={`px-3 py-1.5 rounded-lg text-sm font-medium transition-all flex items-center gap-2 ${isSelected ? 'bg-edeka-blue text-white shadow-md' : 'bg-gray-100 text-gray-600 hover:bg-gray-200'}`} data-id="element-1217">
                  <Icon size={14} data-id="element-1218" />
                  {level.name}
                </button>;
          })}
          </div>
        </div>
      </Card>

      {/* KPI Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-1219">
        <KPICard title="Korrelation Services ↔ Rating" value={correlation.toFixed(2)} change={correlation > 0.6 ? 'Stark positiv' : correlation > 0.3 ? 'Moderat' : 'Schwach'} trend="up" icon={<TrendingUp size={18} data-id="element-1221" />} subtext="Pearson-Koeffizient" data-id="element-1220" />
        <KPICard title="Ø Services pro Markt" value={avgServices.toFixed(1)} change={`von ${services.length} möglich`} trend="up" icon={<Package size={18} data-id="element-1223" />} subtext="Durchschnitt" data-id="element-1222" />
        <KPICard title="Top Service-Effekt" value={`+${topImpactServices[0]?.impact.toFixed(2) || 0}★`} change={topImpactServices[0]?.name || '-'} trend="up" icon={<Star size={18} data-id="element-1225" />} subtext="Rating-Unterschied" data-id="element-1224" />
        <KPICard title="Ø Bewertung" value={avgRating.toFixed(2)} change="+0.15" trend="up" icon={<Star size={18} data-id="element-1227" />} subtext="Google Rating" data-id="element-1226" />
      </div>

      {selectedLevel === 'services' ? <>
          {/* Service Count vs Rating Scatter - Full Width */}
          <Card data-id="element-1228">
            <div className="p-6" data-id="element-1229">
              <h3 className="text-lg font-semibold text-gray-900 mb-1" data-id="element-1230">
                Anzahl Services vs. Rating
              </h3>
              <p className="text-sm text-gray-500 mb-4" data-id="element-1231">
                Korrelation zwischen Service-Angebot und Bewertung
              </p>

              <div className="h-72" data-id="element-1232">
                <ResponsiveContainer width="100%" height="100%" data-id="element-1233">
                  <ScatterChart margin={{
                top: 20,
                right: 20,
                bottom: 20,
                left: 20
              }} data-id="element-1234">
                    <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" data-id="element-1235" />
                    <XAxis type="number" dataKey="serviceCount" name="Services" domain={[0, 15]} axisLine={false} tickLine={false} tick={{
                  fontSize: 11,
                  fill: '#9ca3af'
                }} label={{
                  value: 'Anzahl Services',
                  position: 'bottom',
                  offset: 0,
                  style: {
                    fontSize: 11,
                    fill: '#6b7280'
                  }
                }} data-id="element-1236" />
                    <YAxis type="number" dataKey="rating" name="Rating" domain={[3.2, 5]} axisLine={false} tickLine={false} tick={{
                  fontSize: 11,
                  fill: '#9ca3af'
                }} label={{
                  value: 'Rating',
                  angle: -90,
                  position: 'insideLeft',
                  style: {
                    fontSize: 11,
                    fill: '#6b7280'
                  }
                }} data-id="element-1237" />
                    <ZAxis type="number" dataKey="z" range={[100, 500]} data-id="element-1238" />
                    <Tooltip contentStyle={{
                  borderRadius: '8px',
                  border: 'none',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                  fontSize: '12px'
                }} content={({
                  active,
                  payload
                }) => {
                  if (active && payload && payload.length) {
                    const data = payload[0].payload;
                    return <div className="bg-white p-3 rounded-lg shadow-lg border border-gray-100" data-id="element-1240">
                              <p className="font-medium text-gray-900 text-sm mb-2" data-id="element-1241">
                                {data.name.replace('EDEKA ', '').replace('Center ', '')}
                              </p>
                              <div className="space-y-1 text-xs" data-id="element-1242">
                                <p className="text-gray-600" data-id="element-1243">
                                  <span className="font-medium" data-id="element-1244">Services:</span>{' '}
                                  {data.serviceCount}
                                </p>
                                <p className="text-gray-600" data-id="element-1245">
                                  <span className="font-medium" data-id="element-1246">Rating:</span>{' '}
                                  {data.rating.toFixed(1)} ★
                                </p>
                              </div>
                            </div>;
                  }
                  return null;
                }} data-id="element-1239" />
                    <Scatter name="Märkte" data={correlationData} fill="#003051" data-id="element-1247">
                      {correlationData.map((entry, index) => <Cell key={`cell-${index}`} fill={entry.serviceCount >= avgServices ? '#639754' : '#E03C32'} fillOpacity={0.7} data-id="element-1248" />)}
                    </Scatter>
                  </ScatterChart>
                </ResponsiveContainer>
              </div>

              <div className="mt-4 p-3 bg-blue-50 rounded-lg" data-id="element-1249">
                <div className="text-sm text-blue-800" data-id="element-1250">
                  <strong data-id="element-1251">
                    Korrelation: {(correlation * 100).toFixed(0)}%
                  </strong>{' '}
                  – Märkte mit mehr Services haben tendenziell bessere
                  Bewertungen.
                </div>
              </div>
            </div>
          </Card>

          {/* Service Impact Chart */}
          <Card data-id="element-1252">
            <div className="p-6" data-id="element-1253">
              <div className="flex items-center justify-between mb-6" data-id="element-1254">
                <div data-id="element-1255">
                  <h3 className="text-lg font-semibold text-gray-900" data-id="element-1256">
                    Service-Auswirkung auf Rating
                  </h3>
                  <p className="text-sm text-gray-500" data-id="element-1257">
                    Durchschnittliches Rating: Mit Service vs. Ohne Service
                  </p>
                </div>
              </div>

              <div className="h-[500px]" data-id="element-1258">
                <ResponsiveContainer width="100%" height="100%" data-id="element-1259">
                  <BarChart data={serviceImpactData} layout="vertical" margin={{
                top: 5,
                right: 30,
                left: 140,
                bottom: 5
              }} data-id="element-1260">
                    <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" horizontal={true} vertical={false} data-id="element-1261" />
                    <XAxis type="number" domain={[3, 5]} axisLine={false} tickLine={false} tick={{
                  fontSize: 11,
                  fill: '#9ca3af'
                }} data-id="element-1262" />
                    <YAxis type="category" dataKey="name" axisLine={false} tickLine={false} tick={{
                  fontSize: 12,
                  fill: '#374151'
                }} width={130} data-id="element-1263" />
                    <Tooltip contentStyle={{
                  borderRadius: '8px',
                  border: 'none',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                  fontSize: '12px'
                }} formatter={(value: number, name: string) => [value.toFixed(2) + ' ★', name === 'avgRatingWith' ? 'Mit Service' : 'Ohne Service']} data-id="element-1264" />
                    <Bar dataKey="avgRatingWith" name="Mit Service" fill="#639754" radius={[0, 4, 4, 0]} barSize={16} data-id="element-1265" />
                    <Bar dataKey="avgRatingWithout" name="Ohne Service" fill="#E03C32" radius={[0, 4, 4, 0]} barSize={16} data-id="element-1266" />
                  </BarChart>
                </ResponsiveContainer>
              </div>

              <div className="mt-4 pt-4 border-t border-gray-100 flex items-center justify-center gap-8 text-sm" data-id="element-1267">
                <div className="flex items-center gap-2" data-id="element-1268">
                  <div className="w-3 h-3 rounded" style={{
                backgroundColor: '#639754'
              }} data-id="element-1269"></div>
                  <span className="text-gray-600" data-id="element-1270">Mit Service</span>
                </div>
                <div className="flex items-center gap-2" data-id="element-1271">
                  <div className="w-3 h-3 rounded" style={{
                backgroundColor: '#E03C32'
              }} data-id="element-1272"></div>
                  <span className="text-gray-600" data-id="element-1273">Ohne Service</span>
                </div>
              </div>
            </div>
          </Card>

          {/* Top Impact Services - Full Width */}
          <Card data-id="element-1274">
            <div className="p-6" data-id="element-1275">
              <h3 className="text-lg font-semibold text-gray-900 mb-1 flex items-center gap-2" data-id="element-1276">
                <ArrowUpRight className="text-green-600" size={20} data-id="element-1277" />
                Höchster Rating-Effekt
              </h3>
              <p className="text-sm text-gray-500 mb-4" data-id="element-1278">
                Services mit größtem positiven Einfluss auf Bewertungen
              </p>

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-3" data-id="element-1279">
                {topImpactServices.map((service, index) => {
              const ServiceIcon = service.icon;
              return <motion.div key={service.id} initial={{
                opacity: 0,
                y: 20
              }} animate={{
                opacity: 1,
                y: 0
              }} transition={{
                delay: index * 0.1
              }} className="flex flex-col items-center p-4 rounded-lg text-center" style={{
                backgroundColor: '#e8f0e5'
              }} data-id="element-1280">
                      <div className="w-12 h-12 rounded-lg flex items-center justify-center mb-3" style={{
                  backgroundColor: '#639754'
                }} data-id="element-1281">
                        <ServiceIcon size={24} className="text-white" data-id="element-1282" />
                      </div>
                      <div className="font-medium text-gray-900 text-sm mb-1" data-id="element-1283">
                        {service.name}
                      </div>
                      <div className="font-bold text-xl" style={{
                  color: '#639754'
                }} data-id="element-1284">
                        +{service.impact.toFixed(2)} ★
                      </div>
                      <div className="text-xs text-gray-500 mt-1" data-id="element-1285">
                        {service.marketsCount} Märkte (
                        {service.penetration.toFixed(0)}%)
                      </div>
                    </motion.div>;
            })}
              </div>
            </div>
          </Card>

          {/* Service Penetration Table */}
          <Card data-id="element-1286">
            <div className="p-6" data-id="element-1287">
              <h3 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-1288">
                Service-Übersicht
              </h3>

              <div className="overflow-x-auto" data-id="element-1289">
                <table className="w-full text-sm" data-id="element-1290">
                  <thead data-id="element-1291">
                    <tr className="border-b border-gray-200" data-id="element-1292">
                      <th className="text-left py-3 px-4 font-medium text-gray-500" data-id="element-1293">
                        Service
                      </th>
                      <th className="text-right py-3 px-4 font-medium text-gray-500" data-id="element-1294">
                        Märkte
                      </th>
                      <th className="text-right py-3 px-4 font-medium text-gray-500" data-id="element-1295">
                        Penetration
                      </th>
                      <th className="text-right py-3 px-4 font-medium text-gray-500" data-id="element-1296">
                        Ø Rating mit
                      </th>
                      <th className="text-right py-3 px-4 font-medium text-gray-500" data-id="element-1297">
                        Ø Rating ohne
                      </th>
                      <th className="text-right py-3 px-4 font-medium text-gray-500" data-id="element-1298">
                        Effekt
                      </th>
                    </tr>
                  </thead>
                  <tbody data-id="element-1299">
                    {serviceImpactData.map(service => {
                  const ServiceIcon = service.icon;
                  return <tr key={service.id} className="border-b border-gray-100 hover:bg-gray-50" data-id="element-1300">
                          <td className="py-3 px-4" data-id="element-1301">
                            <div className="flex items-center gap-2" data-id="element-1302">
                              <ServiceIcon size={16} className="text-gray-400" data-id="element-1303" />
                              <span className="font-medium text-gray-900" data-id="element-1304">
                                {service.name}
                              </span>
                            </div>
                          </td>
                          <td className="py-3 px-4 text-right text-gray-900" data-id="element-1305">
                            {service.marketsCount}
                          </td>
                          <td className="py-3 px-4 text-right" data-id="element-1306">
                            <div className="flex items-center justify-end gap-2" data-id="element-1307">
                              <div className="w-16 h-2 bg-gray-200 rounded-full overflow-hidden" data-id="element-1308">
                                <div className="h-full rounded-full" style={{
                            width: `${service.penetration}%`,
                            backgroundColor: '#003051'
                          }} data-id="element-1309" />
                              </div>
                              <span className="text-gray-500 w-10 text-right" data-id="element-1310">
                                {service.penetration.toFixed(0)}%
                              </span>
                            </div>
                          </td>
                          <td className="py-3 px-4 text-right font-medium text-gray-900" data-id="element-1311">
                            {service.avgRatingWith.toFixed(2)} ★
                          </td>
                          <td className="py-3 px-4 text-right text-gray-500" data-id="element-1312">
                            {service.avgRatingWithout.toFixed(2)} ★
                          </td>
                          <td className="py-3 px-4 text-right" data-id="element-1313">
                            <span className={`font-medium ${service.impact > 0 ? 'text-green-600' : service.impact < 0 ? 'text-red-600' : 'text-gray-500'}`} data-id="element-1314">
                              {service.impact > 0 ? '+' : ''}
                              {service.impact.toFixed(2)} ★
                            </span>
                          </td>
                        </tr>;
                })}
                  </tbody>
                </table>
              </div>
            </div>
          </Card>
        </> : <>
          {/* Market View */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-1315">
            {/* Top Service Markets */}
            <Card data-id="element-1316">
              <div className="p-6" data-id="element-1317">
                <h3 className="text-lg font-semibold text-gray-900 mb-1 flex items-center gap-2" data-id="element-1318">
                  <ArrowUpRight className="text-green-600" size={20} data-id="element-1319" />
                  Märkte mit meisten Services
                </h3>
                <p className="text-sm text-gray-500 mb-4" data-id="element-1320">
                  Höchstes Service-Angebot
                </p>

                <div className="space-y-3" data-id="element-1321">
                  {topServiceMarkets.map((market, index) => <motion.div key={market.id} initial={{
                opacity: 0,
                x: -20
              }} animate={{
                opacity: 1,
                x: 0
              }} transition={{
                delay: index * 0.1
              }} className="flex items-center justify-between p-3 rounded-lg" style={{
                backgroundColor: '#e8f0e5'
              }} data-id="element-1322">
                      <div className="flex items-center gap-3" data-id="element-1323">
                        <div className="w-8 h-8 rounded-full flex items-center justify-center text-white font-bold text-sm" style={{
                    backgroundColor: '#639754'
                  }} data-id="element-1324">
                          {index + 1}
                        </div>
                        <div data-id="element-1325">
                          <div className="font-medium text-gray-900 text-sm" data-id="element-1326">
                            {market.name}
                          </div>
                          <div className="text-xs text-gray-500" data-id="element-1327">
                            {market.region}
                          </div>
                        </div>
                      </div>
                      <div className="text-right" data-id="element-1328">
                        <div className="font-bold text-lg" style={{
                    color: '#639754'
                  }} data-id="element-1329">
                          {market.services.length} Services
                        </div>
                        <div className="text-xs text-gray-500" data-id="element-1330">
                          {market.rating.toFixed(1)} ★
                        </div>
                      </div>
                    </motion.div>)}
                </div>
              </div>
            </Card>

            {/* Low Service Markets */}
            <Card data-id="element-1331">
              <div className="p-6" data-id="element-1332">
                <h3 className="text-lg font-semibold text-gray-900 mb-1 flex items-center gap-2" data-id="element-1333">
                  <ArrowDownRight className="text-red-600" size={20} data-id="element-1334" />
                  Märkte mit wenigsten Services
                </h3>
                <p className="text-sm text-gray-500 mb-4" data-id="element-1335">
                  Potenzial für Service-Erweiterung
                </p>

                <div className="space-y-3" data-id="element-1336">
                  {lowServiceMarkets.map((market, index) => <motion.div key={market.id} initial={{
                opacity: 0,
                x: -20
              }} animate={{
                opacity: 1,
                x: 0
              }} transition={{
                delay: index * 0.1
              }} className="flex items-center justify-between p-3 rounded-lg" style={{
                backgroundColor: '#fce8e7'
              }} data-id="element-1337">
                      <div className="flex items-center gap-3" data-id="element-1338">
                        <div className="w-8 h-8 rounded-full flex items-center justify-center text-white font-bold text-sm" style={{
                    backgroundColor: '#E03C32'
                  }} data-id="element-1339">
                          !
                        </div>
                        <div data-id="element-1340">
                          <div className="font-medium text-gray-900 text-sm" data-id="element-1341">
                            {market.name}
                          </div>
                          <div className="text-xs text-gray-500" data-id="element-1342">
                            {market.region}
                          </div>
                        </div>
                      </div>
                      <div className="text-right" data-id="element-1343">
                        <div className="font-bold text-lg" style={{
                    color: '#E03C32'
                  }} data-id="element-1344">
                          {market.services.length} Services
                        </div>
                        <div className="text-xs text-gray-500" data-id="element-1345">
                          {market.rating.toFixed(1)} ★
                        </div>
                      </div>
                    </motion.div>)}
                </div>

                <div className="mt-4 p-3 bg-blue-50 rounded-lg" data-id="element-1346">
                  <div className="text-sm text-blue-800" data-id="element-1347">
                    <strong data-id="element-1348">Empfehlung:</strong> Diese Märkte könnten von
                    zusätzlichen Services wie Fischtheke, Käsetheke oder Scan &
                    Go profitieren.
                  </div>
                </div>
              </div>
            </Card>
          </div>

          {/* Market Service Matrix */}
          <Card data-id="element-1349">
            <div className="p-6" data-id="element-1350">
              <h3 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-1351">
                Service-Matrix nach Markt
              </h3>

              <div className="overflow-x-auto" data-id="element-1352">
                <table className="w-full text-sm" data-id="element-1353">
                  <thead data-id="element-1354">
                    <tr className="border-b border-gray-200" data-id="element-1355">
                      <th className="text-left py-3 px-4 font-medium text-gray-500 sticky left-0 bg-white" data-id="element-1356">
                        Markt
                      </th>
                      <th className="text-right py-3 px-2 font-medium text-gray-500" data-id="element-1357">
                        Rating
                      </th>
                      <th className="text-center py-3 px-2 font-medium text-gray-500" data-id="element-1358">
                        #
                      </th>
                      {services.slice(0, 10).map(service => {
                    const ServiceIcon = service.icon;
                    return <th key={service.id} className="text-center py-3 px-1 font-medium text-gray-500" title={service.name} data-id="element-1359">
                            <ServiceIcon size={14} className="mx-auto" data-id="element-1360" />
                          </th>;
                  })}
                    </tr>
                  </thead>
                  <tbody data-id="element-1361">
                    {marketsByServices.map(market => <tr key={market.id} className="border-b border-gray-100 hover:bg-gray-50" data-id="element-1362">
                        <td className="py-2 px-4 font-medium text-gray-900 sticky left-0 bg-white text-xs" data-id="element-1363">
                          {market.name.replace('EDEKA ', '').replace('Center ', '')}
                        </td>
                        <td className="py-2 px-2 text-right" data-id="element-1364">
                          <span className={`font-medium ${market.rating >= 4.3 ? 'text-green-600' : market.rating >= 3.8 ? 'text-gray-900' : 'text-red-600'}`} data-id="element-1365">
                            {market.rating.toFixed(1)}
                          </span>
                        </td>
                        <td className="py-2 px-2 text-center font-medium text-gray-500" data-id="element-1366">
                          {market.services.length}
                        </td>
                        {services.slice(0, 10).map(service => <td key={service.id} className="py-2 px-1 text-center" data-id="element-1367">
                            {market.services.includes(service.id) ? <CheckCircle2 size={14} className="mx-auto text-green-500" data-id="element-1368" /> : <XCircle size={14} className="mx-auto text-gray-200" data-id="element-1369" />}
                          </td>)}
                      </tr>)}
                  </tbody>
                </table>
              </div>
            </div>
          </Card>
        </>}
    </div>;
}